// extracted by mini-css-extract-plugin
export var text = "_48-0";